import css from './aio.less'
import React from "react"
import cn from 'classnames'
import AioLabel from './AioLabel'
import type {RadioButtonProps} from '../RadioButton';
import RadioButton from '../RadioButton'
import type {RadioGroupProps} from '../RadioGroup';
import RadioGroup from '../RadioGroup'

export interface AioRadioProps extends Omit<RadioGroupProps,'children'> {
    labelClass?: string
    /** @deprecated unused */
    inputClass?: string
    required?: boolean
    inline?: boolean
    loading?: boolean
    label: string
    error?: boolean
    disabled?: boolean
    width?: number | string
    minWidth?: number | string
    maxWidth?: number | string
    buttons: RadioButtonProps[]
    white?: boolean
}

const AioRadio: React.FC<AioRadioProps> = (({
    width,
    minWidth,
    maxWidth,
    label,
    inputClass,
    error,
    disabled,
    labelClass,
    required,
    loading,
    inline,
    testId,
    buttons,
    ...groupProps
}: AioRadioProps) => {
    return (
        <div className={cn(css.borderOnly, {
            [css.disabled]: disabled,
            [css.loading]: loading,
            [css.inline]: inline,
            [css.error]: error
        })}
             style={{width, minWidth, maxWidth}}>
            <RadioGroup {...groupProps}>
                {buttons?.map((btn, idx) => <RadioButton key={idx} testId={testId && btn.value ? `${testId}-${btn.value}` : undefined} {...btn}/>)}
            </RadioGroup>
            <AioLabel className={labelClass} required={required}>{label}</AioLabel>
        </div>
    )
})


export default AioRadio

